/**
 * MUST stay the first import: Zod reads its `jitless` flag when a schema is constructed, and the
 * domain schemas below are constructed at module-evaluation time. See ./zodConfig.
 */
import './zodConfig';

import React from 'react';
import { createRoot } from 'react-dom/client';

/**
 * Has to be included before design system stylesheet because it defines styles in the global space on: body, table
 */
import 'tinymce/skins/ui/oxide/content.css';

/**
 * Mantine css imports
 */
import '@mantine/core/styles/Alert.css';
import '@mantine/core/styles/Button.css';
import '@mantine/core/styles/CloseButton.css';
import '@mantine/core/styles/Combobox.css';
import '@mantine/core/styles/default-css-variables.css';
import '@mantine/core/styles/Input.css';
import '@mantine/core/styles/Popover.css';
import '@mantine/core/styles/UnstyledButton.css';

/**
 * NOTE that import order is important, the shared-ui CSS MUST be imported prior
 * to App to apply modular styles AFTER library styles
 */
import App from './App';
import './style/styles.scss';

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
